import { RootState } from 'redux/store';

export const getMessageTextSelector = (state: RootState) => state.message.message;
